import script from "./KCGame.vue?vue&type=script&setup=true&lang=ts"
export * from "./KCGame.vue?vue&type=script&setup=true&lang=ts"

import "./KCGame.vue?vue&type=style&index=0&id=e9b0539e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e9b0539e"]])

export default __exports__